import * as React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { LayoutStoreInstance } from '../LayoutStore';
import i18n from '@/utils/i18n';

export interface IButtonWithConfirmationProps {
  onConfirmed: () => void;
  size?: any;
  color?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  confirmationHeader?: boolean;
  confirmationText: string;
  className?: string;
  confirmationHeaderText?: string;
  children?: React.ReactNode;
}

export interface IButtonWithConfirmationState {
  showConfirmationDialog: boolean;
}

export class ButtonWithConfirmation extends React.Component<
  IButtonWithConfirmationProps,
  IButtonWithConfirmationState
> {
  constructor(
    props: IButtonWithConfirmationProps,
    state: IButtonWithConfirmationState,
  ) {
    super(props, state);
    this.state = { showConfirmationDialog: LayoutStoreInstance.isStoring() };
  }

  render() {
    return [
      <Button
        key="button"
        className={this.props.className}
        style={this.props.style}
        onClick={() => this.setState({ showConfirmationDialog: true })}
        color={this.props.color}
        size={this.props.size}
        disabled={this.props.disabled}
        children={this.props.children}
      />,
      <Modal
        key="modal"
        isOpen={this.state.showConfirmationDialog}
        toggle={() => this.setState({ showConfirmationDialog: false })}
      >
        <ModalHeader>
          {this.props.confirmationHeaderText ||
            this.props.confirmationHeader ||
            i18n.t('Common:areYouSure')}
        </ModalHeader>
        <ModalBody>
          <p>{this.props.confirmationText}</p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            className="text-white"
            onClick={() => {
              this.props.onConfirmed();
              this.setState({ showConfirmationDialog: false });
            }}
          >
            {i18n.t('Common:confirm')}
          </Button>
          <Button
            color="danger"
            onClick={() => this.setState({ showConfirmationDialog: false })}
          >
            {i18n.t('Common:abort')}
          </Button>
        </ModalFooter>
      </Modal>,
    ];
  }
}
